<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja adresu
                </h1>
            </v-card-title>

            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                :value="delivery.companyName"
                                label="Nazwa firmy"
                                readonly
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                :value="delivery.firstName"
                                label="Imię"
                                readonly
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                :value="delivery.lastName"
                                label="Nazwisko"
                                readonly
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :value="delivery.street"
                                label="Ulica"
                                readonly
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                :value="delivery.zipCode"
                                label="Kod pocztowy"
                                readonly
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="8">
                            <v-text-field
                                :value="delivery.city"
                                label="Miasto"
                                readonly
                                outlined
                                dense
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                :value="delivery.country"
                                :items="countries"
                                label="Kraj"
                                item-text="name"
                                item-value="countryCode"
                                outlined
                                :error="!delivery.postCodeProperlyValidated"
                                dense
                                @change="changeCountry"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Zapisz"
                    @click="updateDelivery"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'DeliveryDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        orderId: {
            type: Number,
            default: null
        },
        deliveryData: {
            type: Object,
            default: () => {}
        },
        countries: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            delivery: {
                country: null,
                postCodeProperlyValidated: false
            },
            actionLoading: false
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.delivery = JSON.parse(JSON.stringify(this.deliveryData))
            } else {
                setTimeout(() => {
                    this.delivery = {
                        country: null,
                        postCodeProperlyValidated: false
                    }
                }, 500)
            }
        }
    },
    methods: {
        changeCountry(value) {
            this.delivery.country = value
            this.delivery.postCodeProperlyValidated = true
        },
        updateDelivery() {
            this.actionLoading = true

            this.$store.dispatch('orders/updateDelivery', {
                id: this.deliveryData.id,
                payload: {
                    country: this.delivery.country
                }
            })
                .then(response => {
                    this.$emit('on-save', response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onSave(payload) {
            this.$emit('on-save', payload)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>

